<ng-container *ngIf="immediateFeedBackRequired">
  <div class="next-button-spacing-position">
    <button *ngIf="!questionChecked" (click)="review()" [class.disabled]="!questionAttempted"
      class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20 me-4"><span>Review</span></button>
    <button *ngIf="!(isLastQuestion||isLastIndex) && questionChecked" (click)="next()"
      class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20 me-4"><span>Next</span></button>
    <button *ngIf="(isLastQuestion||isLastIndex) && questionChecked" (click)="submit()" [disabled]="!isLastQuestion"
      class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20 me-4 has-tooltip">
      <span>Submit</span>
      <span *ngIf="!isLastQuestion" class="custom-tooltip custom-tooltip__top white-space-wrap">Please answer all
        questions to continue</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!immediateFeedBackRequired">
  <div class="next-button-spacing-position">
    <button *ngIf="!(isLastQuestion||isLastIndex)" [class.disabled]="!questionAttempted" (click)="next()"
      class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20 me-4"><span>Save & Next</span></button>
    <button *ngIf="(isLastQuestion||isLastIndex)" [disabled]="!questionAttempted||!isLastQuestion" (click)="submit()"
      class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20 me-4" [class.has-tooltip]="!questionAttempted||!isLastQuestion">
      <span>Submit</span>
      <span *ngIf="!questionAttempted||!isLastQuestion"
        class="custom-tooltip custom-tooltip__top white-space-wrap">Please answer all questions to continue</span>
    </button>
  </div>
</ng-container>